import { Link } from "react-router-dom";
import { Instagram, Mail } from "lucide-react";

const Footer = () => (
  <footer
    className="bg-[#4F5D4F] text-[#F6F1EA] mt-24"
    data-testid="site-footer"
  >
    <div className="max-w-[1400px] mx-auto px-6 sm:px-12 lg:px-16 py-24 grid grid-cols-1 md:grid-cols-12 gap-12">
      <div className="md:col-span-6">
        <div className="flex items-center gap-4 mb-6">
          <img
            src="https://customer-assets.emergentagent.com/job_session-booking-23/artifacts/q6ceh14a_Jess%20Eisaman%20Co.%20%281%29.png"
            alt="Jess Eisaman Co."
            className="h-16 w-16 object-contain bg-[#F6F1EA] p-2 rounded-full shrink-0"
            data-testid="footer-logo-mark"
          />
          <div className="font-serif text-3xl sm:text-4xl leading-tight">
            Jess Eisaman<span className="text-[#B89B63]"> </span>Co.
          </div>
        </div>
        <p className="text-[#F6F1EA]/80 max-w-md leading-relaxed">
          Transformative coaching for women ready to live with courage,
          intention, and untamed joy. Currently offering the <em>Bravely You</em> program — with more to come.
        </p>
      </div>

      <div className="md:col-span-3">
        <p className="text-xs tracking-eyebrow uppercase text-[#B89B63] mb-5">
          Explore
        </p>
        <ul className="space-y-3 text-sm">
          <li><a href="/#about" className="hover:text-[#D7B2A3] transition-colors" data-testid="footer-link-about">About Jess</a></li>
          <li><a href="/#services" className="hover:text-[#D7B2A3] transition-colors" data-testid="footer-link-services">Coaching</a></li>
          <li><a href="/#faq" className="hover:text-[#D7B2A3] transition-colors" data-testid="footer-link-faq">FAQ</a></li>
          <li><Link to="/booking" className="hover:text-[#D7B2A3] transition-colors" data-testid="footer-link-book">Book a Session</Link></li>
        </ul>
      </div>

      <div className="md:col-span-3">
        <p className="text-xs tracking-eyebrow uppercase text-[#B89B63] mb-5">
          Connect
        </p>
        <ul className="space-y-3 text-sm">
          <li className="flex items-center gap-3">
            <Mail size={16} className="text-[#D7B2A3]" />
            <a href="mailto:hello@jesseisamanco.com" className="hover:text-[#D7B2A3] transition-colors" data-testid="footer-email">
              hello@jesseisamanco.com
            </a>
          </li>
          <li className="flex items-center gap-3">
            <Instagram size={16} className="text-[#D7B2A3]" />
            <a href="https://instagram.com/jesseisaman" target="_blank" rel="noreferrer" className="hover:text-[#D7B2A3] transition-colors" data-testid="footer-instagram">
              @jesseisaman
            </a>
          </li>
        </ul>
      </div>
    </div>

    <div className="border-t border-[#F6F1EA]/15">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-12 lg:px-16 py-6 flex flex-col sm:flex-row justify-between text-xs text-[#F6F1EA]/60">
        <p>© {new Date().getFullYear()} Jess Eisaman Co. All rights reserved.</p>
        <p className="tracking-eyebrow uppercase">Made with intention</p>
      </div>
    </div>
  </footer>
);

export default Footer;
